import { Typography } from '@euler/app/components/typography';
import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../../workshopBoardColors';

/** One count: `null` while it loads, as `--` in its place. */
export const MetricCard = memo(
  ({
    label,
    value,
    color = colors.foreground,
  }: {
    label: string;
    value: number | null;
    color?: string;
  }) => {
    const u = useBoardUnit();
    return (
      <View
        style={{
          flex: 1,
          gap: u(8),
          paddingHorizontal: u(28),
          paddingVertical: u(22),
          borderRadius: u(18),
          backgroundColor: colors.card,
        }}
      >
        <Typography.Text size={u(22)} color={colors.muted} numberOfLines={1}>
          {label}
        </Typography.Text>
        <Typography.Text
          size={u(64)}
          bold
          color={value == null ? colors.faint : color}
          lineHeight={u(76)}
          style={{ fontVariant: ['tabular-nums'] }}
        >
          {value ?? '--'}
        </Typography.Text>
      </View>
    );
  },
);
